import store from '@/store';
import { newEvent } from '@/shared/utils/notification-title';
import randomColor from '@/shared/utils/random-color';
import moment from 'moment';
import { SET_JOB_CHANNEL } from '@/store/mutation-types.js';
import { EventBus } from '@/event-bus.js';

export default class NewWhatsAppEvent {
  constructor(body) {
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));
    this.job = body;

    this.job.observation = this.job.observation || '';

    if (this.job.observation) {
      store.dispatch('observation/newObservation', {
        observation: this.job.observation,
        protocol: this.job.protocol,
      });
    }

    this.job.color = randomColor();
    this.job.channel = 'WhatsApp';
    this.job.messages = [];
    this.job.history = [];
    this.job.time = 0;
    this.job.transferCount = body.transferCount ? body.transferCount : 0;
    this.job.disabled = this.job.closedWithoutQualify || false;
    this.job.lastMessage = this.job.lastMessage || '';
    this.job.notifications = !this.job.newAttendance
      ? this.job.agentUnreadMessages
      : 1;
    this.job.messagesNotRead = this.job.newAttendance
      ? (this.job.agentUnreadMessages || 0) + 1
      : this.job.agentUnreadMessages || 0;

    this.job.tab = {
      active: 0,
      tab: 'message',
    };

    this.job.paramsHistoryMessages = {
      page: 1,
      initialDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    };

    EventBus.$emit('close-toggle-infobars');
    store.dispatch('jobs/addNewJob', this.job);
    store.commit(`jobs/${SET_JOB_CHANNEL}`, 'WhatsApp');
    newEvent();
  }
}
